/**
 * Cache utility functions.
 * Extracted from WanderAppComplete.jsx for shared use by web and mobile.
 */

export const DYNAMIC_CACHE_MAX = 500;

export const evictOldestFromCache = (cache, maxSize) => {
  const keys = Object.keys(cache);
  if (keys.length > maxSize) {
    const toRemove = Math.floor(maxSize * 0.2);
    keys.slice(0, toRemove).forEach(k => delete cache[k]);
  }
};
